import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

// Fetch all blogs
const getBlogs = async () => {
  const response = await axios.get(`${base_url}blog/`);
  return response.data;
};

// Create a blog
const createBlog = async (blog) => {
  const response = await axios.post(`${base_url}blog/`, blog, config);
  return response.data;
};

// Update a blog by slug
const updateBlog = async (blog) => {
  const response = await axios.put(
    `${base_url}blog/${blog.slug}`, // ✅ use slug, not id
    {
      title: blog.blogData.title,
      description: blog.blogData.description,
      category: blog.blogData.category,
      images: blog.blogData.images,
    },
    config
  );
  return response.data;
};

// Get a single blog by slug
const getBlog = async (slug) => {
  const response = await axios.get(`${base_url}blog/${slug}`);
  return response.data;
};

// Delete a blog by slug
const deleteBlog = async (slug) => {
  const response = await axios.delete(`${base_url}blog/${slug}`, config);
  return response.data;
};

const blogService = {
  getBlogs,
  createBlog,
  getBlog,
  updateBlog,
  deleteBlog,
};

export default blogService;
